import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentModal = styled.div`
  width: 600px;
  height: fit-content;
  max-width: 70%;
  background: #f2f2f2;
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 10px;
  overflow: auto;
  .MuiTypography-body1 {
    font-size: 14px;
  }
`;

export const CloseModal = styled.div`
  height: 3.5em;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  background: linear-gradient(0.09deg, ${({ theme }) => theme.primary.purple} 0.08%, ${({ theme }) => theme.primary.purple} 112.36%);
`;

export const TextModal = styled.div`
  margin: 1em 2em;
  overflow: auto;
  height: 237px;
  .subject {
    font-size: 22px;
    font-weight: 700;
    width: 100%;
    line-height: 30px;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.secondaryDarkOne};
  }
  .body {
    margin-top: 0.5em;
  }
  .body p {
    color: ${({ theme }) => theme.secondaryDarkOne};
    font-size: 20px;
  }
  .body p:nth-child(n + 2),
  .body p:nth-child(even) {
    line-height: 0.7em;
  }
`;

export const ButtonAttend = styled.button`
  color: white;
  width: 60px;
  height: 32px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 8px;
  border: none;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
